import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { ChargingType } from '/src/lib/models/ChargingType';

export class ChargingTypeService {
  /**
   * List Charging Type
   * @returns ChargingType[]
   * @throws ApiError
   */
  public static listChargingTypes(): CancelablePromise<ChargingType[]> {
    return __request(OpenAPI, { method: 'GET', url: '/chargingTypes' });
  }
}
